const valueKeyImgSizes = {
  imageWidth: '42',
  imageHeight: '44',
}

export const config = {
  title: 'Modsen custom software development key-facts',
  config: [
    {
      id: 1,
      title: (
        <>
          1 <span>week</span>
        </>
      ),
      subtitle: '1-week long active software development phase launch',
      imagePath: '/',
      ...valueKeyImgSizes,
    },
    {
      id: 2,
      title: (
        <>
          15<span>-day</span>
        </>
      ),
      subtitle: 'free trial period',
      imagePath: '/',
      ...valueKeyImgSizes,
    },
    {
      id: 3,
      title: <span>Senior-level</span>,
      subtitle: 'engineers with relevant project experience',
      imagePath: '/',
      ...valueKeyImgSizes,
    },
    {
      id: 4,
      title: (
        <>
          7+ <span>years</span>
        </>
      ),
      subtitle: 'of experience',
      imagePath: '/',
      ...valueKeyImgSizes,
    },
    {
      id: 5,
      title: '200+',
      subtitle: 'successfully launched products',
      imagePath: '/',
      ...valueKeyImgSizes,
    },
    {
      id: 6,
      title: '10+',
      subtitle: 'Top Developer Company nominations',
      imagePath: '/',
      ...valueKeyImgSizes,
    },
  ],
}
